import { QuestionType } from '.';
import { IbanForm, Redirect } from '../components';
import { Blocker } from '../components/Blocker';
import { AddressForm } from '../components/Forms/AddressForm';
import { AutoSuggestForm } from '../components/Forms/AutoSuggestForm';
import { BooleanForm } from '../components/Forms/BooleanForm';
import { CheckboxForm } from '../components/Forms/CheckboxForm';
import { CountryMultiForm } from '../components/Forms/CountryMultiForm';
import { CountrySingleForm } from '../components/Forms/CountrySingleForm';
import { CurrencyInputForm } from '../components/Forms/CurrencyInputForm';
import { DateForm } from '../components/Forms/DateForm';
import { DropdownSingleForm } from '../components/Forms/DropdownSingleForm';
import { InputForm } from '../components/Forms/InputForm';
import { IntroForm } from '../components/Forms/IntroForm';
import { NameForm } from '../components/Forms/NameForm';
import { NumberInputForm } from '../components/Forms/NumberInputForm';
import { NumericConversionInputForm } from '../components/Forms/NumericConversionInputForm';
import { PhoneForm } from '../components/Forms/PhoneForm';
import { RadioForm } from '../components/Forms/RadioForm';
import { TextForm } from '../components/Forms/TextForm';
import { Success } from '../components/Success';
import { SignatureForm } from '../components/Forms/SignatureForm';

export const componentMapping: Record<
  QuestionType,
  (props: any) => JSX.Element
> = {
  ADDRESS: AddressForm,
  BOOLEAN: BooleanForm,
  CHECKBOX: CheckboxForm,
  COUNTRY_MULTI: CountryMultiForm,
  COUNTRY_SINGLE: CountrySingleForm,
  CURRENCY: CurrencyInputForm,
  DATE: DateForm,
  INPUT: InputForm,
  NAME: NameForm,
  NUMBER: NumberInputForm,
  PHONE: PhoneForm,
  RADIO: RadioForm,
  TEXT: TextForm,
  DROPDOWN_SINGLE: DropdownSingleForm,
  NUMERIC_CONVERSION: NumericConversionInputForm,
  INTRO: IntroForm,
  AUTOSUGGEST: AutoSuggestForm,
  SIGNATURE: SignatureForm,
  BLOCKER: Blocker,
  REDIRECT: Redirect,
  SUCCESS: Success,
  IBAN: IbanForm,
};
